import { MusicIconSVG } from '@ad-lucy/assets';
import { withSwiperPage } from '@ad-lucy/components/builderComponents/VastVideo/withSwiperPage';
import { Arrows } from '@ad-lucy/components/nav/NavigationArrow/types';
import {
  CREATIVE_TYPE,
  type CreativesConfig,
  defaultCreativesConfig,
  SWIPER_DIRECTION,
} from '@ad-lucy/config/creatives';
import { lazy } from 'react';
import type { componentNames } from './componentNames';

export type RaCreativesConfigComponentKeys = (typeof componentNames)[number];

export const raConfig: CreativesConfig<RaCreativesConfigComponentKeys> = {
  ...defaultCreativesConfig,
  id: CREATIVE_TYPE.RA,
  name: 'Reel Ad',
  navigation: {
    ...defaultCreativesConfig.navigation,
    defaults: {
      ...defaultCreativesConfig.navigation.defaults,
      showOnHover: false,
      direction: SWIPER_DIRECTION.VERTICAL,
      loop: true,
      // To ensure a smooth transition between videos loop should not be paused on mouse over which would lead to a disproportion of loop length and video length
      pauseOnMouseEnter: false,
    },
    arrows: Arrows.NONE,
    transition: 'slide',
  },
  settings: {
    ...defaultCreativesConfig.settings,
    commonMuteState: true,
    playIfNotInActiveTab: true,
  },
  breakpoints: {
    ...defaultCreativesConfig.breakpoints,
    hpa: '(max-width: 400px)',
    DOOH: '(width: 1080px) and (height: 1920px)',
  },
  components: {
    logo: {
      ...defaultCreativesConfig.components.logo,
      wrapper: lazy(() => import('@ad-lucy/ra/components/styledBuilderComponents/StyledLogo')),
    },
    closeAd: {
      ...defaultCreativesConfig.components.closeAd,
      defaults: {
        ...defaultCreativesConfig.components.closeAd.defaults,
        centered: true,
      },
    },
    button: {
      ...defaultCreativesConfig.components.button,
      wrapper: lazy(() => import('@ad-lucy/ra/components/CTAButton')),
      defaults: {
        ...defaultCreativesConfig.components.button.defaults,
      },
    },
    vastVideoXL: {
      ...defaultCreativesConfig.components.vastVideoXL,
      wrapper: withSwiperPage(
        lazy(() => import('@ad-lucy/components/builderComponents/VastVideo/VastVideoXL')),
      ),
      defaults: {
        ...defaultCreativesConfig.components.vastVideoXL.defaults,
        controls: false,
        showPlayButton: false,
      },
    },
    likeButton: {
      ...defaultCreativesConfig.components.likeButton,
      wrapper: lazy(
        () => import('@ad-lucy/ra/components/styledBuilderComponents/StyledLikeButton'),
      ),
    },
    tag: {
      ...defaultCreativesConfig.components.tag,
      wrapper: lazy(() => import('@ad-lucy/ra/components/styledBuilderComponents/StyledTag')),
    },
    sharingButton: {
      ...defaultCreativesConfig.components.sharingButton,
      wrapper: lazy(
        () => import('@ad-lucy/ra/components/styledBuilderComponents/StyledSharingButton'),
      ),
    },
    copyright: {
      ...defaultCreativesConfig.components.copyright,
    },
    heading: {
      ...defaultCreativesConfig.components.heading,
      wrapper: lazy(() => import('@ad-lucy/ra/components/styledBuilderComponents/StyledHeading')),
    },
    textConfigure: {
      ...defaultCreativesConfig.components.textV2,
      wrapper: lazy(() => import('@ad-lucy/ra/components/styledBuilderComponents/StyledTextV2')),
    },
    textWithIcon: {
      ...defaultCreativesConfig.components.textV2,
      wrapper: lazy(
        () => import('@ad-lucy/ra/components/styledBuilderComponents/StyledTextWithIcon'),
      ),
      defaults: {
        ...defaultCreativesConfig.components.textV2.defaults,
        leftIcon: <MusicIconSVG />,
        loopAnimation: true,
      },
    },
    videoControls: {
      ...defaultCreativesConfig.components.videoControls,
      wrapper: lazy(
        () => import('@ad-lucy/ra/components/styledBuilderComponents/StyledVideoControls'),
      ),
    },
  },
};
